import { createSlice } from "@reduxjs/toolkit";
import { getReservations } from "./thunk";

export interface IState {
  reservations: any;
  isReservationLoading: boolean;
  isReservationSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  reservations: null,
  isReservationLoading: false,
  isReservationSuccess: false,

  error: {},
};

const ReservationSlice = createSlice({
  name: "Reservation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Reservations
    builder.addCase(getReservations.pending, (state: IState, action: any) => {
      state.isReservationLoading = true;
    });
    builder.addCase(getReservations.fulfilled, (state: IState, action: any) => {
      state.reservations = action.payload.data;
      state.isReservationSuccess = true;
      state.isReservationLoading = false;
    });
    builder.addCase(getReservations.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isReservationSuccess = false;
      state.isReservationLoading = false;
    });
  },
});

export default ReservationSlice.reducer;
